import $ from 'jquery';

class CountdownController {
    static initCountdown(containerID, countDownTo, timeZone, labelD, labelH, labelM, labelS, bgColor) {
        let timezone = timeZone;
        const $container = $(`#${containerID}`);
        if (timezone !== '') {
            timezone = timezone.slice(1, -1).replace(/ /g, '');
        }
        else {
            timezone = 'UTC+00:00';
        }

        const parts = timezone.split(':');
        let offset = parseInt(parts[0].slice(-2), 10);
        if (parts[0].indexOf('-') > -1) {
            offset *= -1;
        }

        let countDownDate = new Date(`${countDownTo}`);
        countDownDate.setMinutes(countDownDate.getMinutes() - countDownDate.getTimezoneOffset() - offset * 60);
        $container.find('#sc_dl').html(labelD);
        $container.find('#sc_hl').html(labelH);
        $container.find('#sc_ml').html(labelM);

        if (bgColor !== '0') {
            $container.find('#sc_d').addClass(`bg-${bgColor}`);
            $container.find('#sc_h').addClass(`bg-${bgColor}`);
            $container.find('#sc_m').addClass(`bg-${bgColor}`);
        }

        $container.find('#sc_sl').html(labelS);

        // init for real width
        $container.find('#sc_d').html('00');
        $container.find('#sc_h').html('00');
        $container.find('#sc_m').html('00');
        $container.find('#sc_s').html('00');

        // get width of parent for resizing
        const parentWidth = $container.width();
        if (parentWidth < 600 && parentWidth > 500) {
            $container.addClass('sos-cd-sm');
        }
        else if (parentWidth < 500) {
            $container.addClass('sos-cd-xs');
        }

        // show countdown
        $container.css('display', 'table');

        countDownDate = countDownDate.getTime();

        function hasDST(dateObj) {
            const jan = new Date(dateObj.getFullYear(), 0, 1);
            const jul = new Date(dateObj.getFullYear(), 6, 1);
            const max = Math.max(Math.abs(jan.getTimezoneOffset()), Math.abs(jul.getTimezoneOffset()));
            return (Math.abs(dateObj.getTimezoneOffset()) < max);
        }

        const x = setInterval(() => {
            let now = new Date();
            let off = 0;
            if (hasDST(now)) {
                off = (now.getTimezoneOffset() + 60) * 60 * 1000;
            }
            else {
                off = now.getTimezoneOffset() * 60 * 1000;
            }

            now = now.getTime() - off;

            const distance = countDownDate - now;

            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            if (days < 10) {
                $container.find('#sc_d').html((`0${days}`).slice(-2));
            }
            else {
                $container.find('#sc_d').html(days);
            }
            $container.find('#sc_h').html((`0${hours}`).slice(-2));
            $container.find('#sc_m').html((`0${minutes}`).slice(-2));
            $container.find('#sc_s').html((`0${seconds}`).slice(-2));

            if (distance < 0) {
                clearInterval(x);
                $container.find('#sc_d').html('00');
                $container.find('#sc_h').html('00');
                $container.find('#sc_m').html('00');
                $container.find('#sc_s').html('00');
            }
        }, 1000);
    }
}

window.CountdownController = CountdownController;
export default CountdownController;
